/**
 * Client-safe error utilities.
 * This file can be imported by both client and server components.
 */

/**
 * Safely extracts an error message from any error type.
 * Handles Error objects, ProgressEvent objects, plain objects, and primitives.
 *
 * @param error - The error to extract a message from
 * @returns A string representation of the error
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'object' && error !== null) {
    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  }
  return String(error);
}
